import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpNotificationsListComponent from './adpNotificationsList.component';

let adpNotificationsListModule = angular.module('adpNotificationsList', [
  uiRouter
])

.component('adpNotificationsList', adpNotificationsListComponent)

.name;

export default adpNotificationsListModule;



// WEBPACK FOOTER //
// ./src/app/components/adpNotificationsList/adpNotificationsList.js